module.exports = __webpack_public_path__ + "static/media/AngelsOfAether_RaceGamePromo_04.b6be7302.jpg";